"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _isString2 = _interopRequireDefault(require("lodash/isString"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _Paragraph = _interopRequireDefault(require("../Typography/Paragraph"));

var _Title = _interopRequireDefault(require("../Typography/Title"));

var _StackingLayout = _interopRequireDefault(require("../Layouts/StackingLayout"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ConfirmModalContent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ConfirmModalContent, _React$Component);

  function ConfirmModalContent(props) {
    var _this;

    _classCallCheck(this, ConfirmModalContent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ConfirmModalContent).call(this, props));
    _this.state = {
      animation: ''
    };
    return _this;
  }
  /**
   * Need to do a 'pre-render' check update for components that rely on DOM measurements when they
   * are updating. Otherwise, the animation will kill their logic.
   */


  _createClass(ConfirmModalContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.visible && this.state.animation === '') {
        // Disabling old rule based on React 15 : react/no-did-update-set-state
        // https://github.com/airbnb/javascript/issues/1875

        /* eslint-disable */
        this.setState({
          animation: this.getAnimation(this.props.visible)
        });
        /* eslint-enable */
      }
    }
    /**
     * Need to do a 'pre-render' check update for components that rely on DOM measurements when they
     * are updating. Otherwise, the animation will kill their logic.
     * @param {object} prevProps - previous props
     * @param {object} prevState - previous state
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.visible !== this.props.visible) {
        // Disabling old rule based on React 15 : react/no-did-update-set-state
        // https://github.com/airbnb/javascript/issues/1875

        /* eslint-disable */
        this.setState({
          animation: this.getAnimation(this.props.visible)
        });
        /* eslint-enable */
      }
    }
    /**
     * Gets a different animation depending on visible value.
     * @param {boolean} visible - visibility state of modal
     * @returns {string} name of animation
     */

  }, {
    key: "getAnimation",
    value: function getAnimation(visible) {
      var animation;

      if (visible) {
        animation = 'zoom-in';
      } else {
        animation = 'zoom-out';
      }

      return animation;
    }
    /**
     * Body for confirm modal
     * @param {node} children - children node
     * @returns {node} of children node
     */

  }, {
    key: "renderChildren",
    value: function renderChildren(children) {
      if ((0, _isString2.default)(children)) {
        return _react.default.createElement(_Paragraph.default, null, children);
      }

      return children;
    }
    /**
     * Footer for confirm modal
     * @param {node} footer - footer node
     * @param {node} cancelButtonLabel - Label for cancel button
     * @param {object} cancelButtonProps - Props to pass to cancel button
     * @param {node} confirmButtonLabel - Label for confirm button
     * @param {object} confirmButtonProps - Props to pass to confirm button
     * @param {function} onCancel - on cancel callback
     * @param {function} onConfirm - on confirm callback
     * @returns {node|null} of footer node
     */

  }, {
    key: "renderFooter",
    value: function renderFooter(footer, cancelButtonLabel, cancelButtonProps, confirmButtonLabel, confirmButtonProps, onCancel, onConfirm) {
      if (footer === true) {
        return _react.default.createElement("div", {
          className: "confirm-footer"
        }, _react.default.createElement(_FlexLayout.default, {
          itemSpacing: "10px",
          justifyContent: "center"
        }, _react.default.createElement(_Button.default, _extends({
          type: "secondary",
          onClick: onCancel
        }, cancelButtonProps), cancelButtonLabel), _react.default.createElement(_Button.default, _extends({
          onClick: onConfirm
        }, confirmButtonProps), confirmButtonLabel)));
      } else if ((0, _isArray2.default)(footer)) {
        return _react.default.createElement("div", {
          className: "confirm-footer"
        }, _react.default.createElement(_FlexLayout.default, {
          itemSpacing: "10px",
          justifyContent: "center"
        }, footer));
      } else if (footer) {
        return _react.default.createElement("div", {
          className: "confirm-footer"
        }, footer);
      }

      return null;
    }
    /**
     * Header for confirm modal
     * @param {node} header - header node
     * @returns {node|null} of header node
     */

  }, {
    key: "renderHeader",
    value: function renderHeader(header) {
      if (!(0, _isUndefined2.default)(header)) {
        return _react.default.createElement("div", {
          className: "confirm-header"
        }, _react.default.createElement(_Title.default, {
          size: "h3"
        }, header));
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      // Don't want to pass {visible} down to nested component. It's already being used as part
      // of state logic.

      /* eslint-disable no-unused-vars */
      var _this$props = this.props,
          children = _this$props.children,
          cancelButtonLabel = _this$props.cancelButtonLabel,
          cancelButtonProps = _this$props.cancelButtonProps,
          confirmButtonLabel = _this$props.confirmButtonLabel,
          confirmButtonProps = _this$props.confirmButtonProps,
          header = _this$props.header,
          footer = _this$props.footer,
          onCancel = _this$props.onCancel,
          onConfirm = _this$props.onConfirm,
          visible = _this$props.visible,
          width = _this$props.width,
          props = _objectWithoutProperties(_this$props, ["children", "cancelButtonLabel", "cancelButtonProps", "confirmButtonLabel", "confirmButtonProps", "header", "footer", "onCancel", "onConfirm", "visible", "width"]);
      /* eslint-enable */


      return _react.default.createElement(_StackingLayout.default, _extends({
        className: "".concat(_ThemeManager.default.getVar('classPrefix'), "-confirm-modal"),
        "data-animation": this.state.animation,
        itemSpacing: "30px",
        style: {
          width: width
        }
      }, props), this.renderHeader(header), _react.default.createElement("div", {
        className: "confirm-body"
      }, this.renderChildren(children)), this.renderFooter(footer, cancelButtonLabel, cancelButtonProps, confirmButtonLabel, confirmButtonProps, onCancel, onConfirm));
    }
  }]);

  return ConfirmModalContent;
}(_react.default.Component);

exports.default = ConfirmModalContent;
ConfirmModalContent.defaultProps = {
  cancelButtonLabel: _I18nManager.default.t('ConfirmModal', 'cancel'),
  confirmButtonLabel: _I18nManager.default.t('ConfirmModal', 'confirm'),
  footer: true,
  width: 400
};
ConfirmModalContent.propTypes = {
  /**
   * Body content goes here.
   */
  children: _propTypes.default.node,

  /**
   * cancelButtonLabel is the label for the secondary action button on the
   * modal footer.
   */
  cancelButtonLabel: _propTypes.default.string,

  /**
   * Props to be passed to cancel button
   */
  cancelButtonProps: _propTypes.default.object,

  /**
   * confirmButtonLabel is the label for the primary action button on the
   * modal footer.
   */
  confirmButtonLabel: _propTypes.default.string,

  /**
   * Props to be passed to confirm button
   */
  confirmButtonProps: _propTypes.default.object,

  /**
   * The header title for the confirm modal.
   */
  header: _propTypes.default.node,

  /**
   * Footer for confirm modal. Can be a node or default as true. Use {false} to remove. When set to a value other than true, the props onConfirm, onCancel, confirmButtonLabel, and cancelButtonLabel will no longer be usable.
   */
  footer: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),

  /**
   * onCancel is used to handle when cancel button is clicked.
   */
  onCancel: _propTypes.default.func,

  /**
   * onConfirm is the action for the primary action button on the
   * modal footer.
   */
  onConfirm: _propTypes.default.func,

  /**
   * Visible is to determine whether a modal dialog is visible or not.
   */
  visible: _propTypes.default.bool,

  /**
   * Width of a modal dialog (in px)
   */
  width: _propTypes.default.number
};